import React from 'react';
import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { fetchVehicle } from '../../../actions';
import { selectVehicle } from '../../../selectors';
import styled from 'styled-components';
import { HBox } from '../../../../../components/Box';
import { Button } from '../../../../../components/Buttons';
import { Loader } from '../../../../../components/Loader';
import { createVehicleWithProps } from '../../../actions';
import { VehicleDocumentsCard } from '../../../../Vehicles/components/CardDocuments';
import { render } from 'react-dom';
import ButtonComponent from '../../../../../containers/App/Components/Button/Button';

const Container = styled.div`
  width: 100%;
  background-color: #fff;

  .btn-block {
    padding: 30px;
  }
`;

class VehicleCreateStep4Comp extends BaseComponent {
  constructor(props) {
    super(props, {});
  }
  componentDidMount() {
    if (!this.props.createdVehicle) {
      this.props.fetch();
    }
  }

  save() {
    this.props.onSave();
  }

  prevStep() {
    this.props.getPrevStep();
  }

  render() {
    if (!this.props.createdVehicle) return <Loader small="true" />;

    return (
      <Container className="container-fluid mt-3">
        <VehicleDocumentsCard isEditPage={true} vehicle={this.props.createdVehicle} />

        <div className="d-flex gap-2 justify-content-end mt-2 mb-3">
          <ButtonComponent style="ButtonSoftPrimary" onClick={this.prevStep.bind(this)}>
            {this.lbl('previous')}
          </ButtonComponent>

          <ButtonComponent style="ButtonSoftEdit" onClick={this.save.bind(this)}>
            {this.lbl('save')}
          </ButtonComponent>
        </div>
      </Container>
    );
  }
}

VehicleCreateStep4Comp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    createdVehicle: selectVehicle(ownProps.vehicle_id),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetch() {
      dispatch(fetchVehicle(ownProps.vehicle_id));
    },
    create(properties, options, callback) {
      dispatch(createVehicleWithProps(properties, options, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const VehicleCreateStep4 = compose(withConnect, withRouter)(VehicleCreateStep4Comp);
